module.exports = MaterialUI.LinearProgress;